<section class="style-guide">
  <div class="style-guide__section">
    <h1 class="style-guide__section__title">Color system</h1>
    <div class="style-guide__section__content">
      <div class="style-guide__section__content__block background--primary">
        <div class="style-guide__section__content__block__title"><span>Primary</span> <span>#fe5757</span></div>
        <div class="style-guide__section__content__block__description">
          <span>Color variable</span> <span>--cx-color-primary</span>
        </div>
        <div class="style-guide__section__content__block__description">
          <span>WCAG contrast</span><span>Pass/fail with icon</span>
        </div>
      </div>
      <div
        class="style-guide__section__content__block style-guide__section__content__block--no-right-margin background--secondary"
      >
        <div class="style-guide__section__content__block__title"><span>Primary</span> <span>#fe5757</span></div>
        <div class="style-guide__section__content__block__description">
          <span>Color variable</span> <span>--cx-color-secondary</span>
        </div>
        <div class="style-guide__section__content__block__description">
          <span>WCAG contrast</span><span>Pass/fail with icon</span>
        </div>
      </div>
    </div>
    <div class="style-guide__section__content">
      <div class="style-guide__section__content__block background--success">
        <div class="style-guide__section__content__block__title"><span>Success</span> <span>#5dac06</span></div>
        <div class="style-guide__section__content__block__description">
          <span>Color variable</span> <span>--cx-color-success</span>
        </div>
        <div class="style-guide__section__content__block__description">
          <span>WCAG contrast</span><span>Pass/fail with icon</span>
        </div>
      </div>
      <div
        class="style-guide__section__content__block style-guide__section__content__block--no-right-margin background--info"
      >
        <div class="style-guide__section__content__block__title"><span>Info</span> <span>#17a2b8</span></div>
        <div class="style-guide__section__content__block__description">
          <span>Color variable</span> <span>--cx-color-info</span>
        </div>
        <div class="style-guide__section__content__block__description">
          <span>WCAG contrast</span><span>Pass/fail with icon</span>
        </div>
      </div>
    </div>
    <div class="style-guide__section__content">
      <div class="style-guide__section__content__block background--warning">
        <div class="style-guide__section__content__block__title"><span>Warning</span> <span>#ffc107</span></div>
        <div class="style-guide__section__content__block__description">
          <span>Color variable</span> <span>--cx-color-warning</span>
        </div>
        <div class="style-guide__section__content__block__description">
          <span>WCAG contrast</span><span>Pass/fail with icon</span>
        </div>
      </div>
      <div
        class="style-guide__section__content__block style-guide__section__content__block--no-right-margin background--danger"
      >
        <div class="style-guide__section__content__block__title"><span>Danger</span> <span>#db0002</span></div>
        <div class="style-guide__section__content__block__description">
          <span>Color variable</span> <span>--cx-color-danger</span>
        </div>
        <div class="style-guide__section__content__block__description">
          <span>WCAG contrast</span><span>Pass/fail with icon</span>
        </div>
      </div>
    </div>
  </div>
  <div class="style-guide__section">
    <h1 class="style-guide__section__title">Theming system</h1>
    <div class="style-guide__section__content">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Color variables</th>
            <th scope="col">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Text</td>
            <td>--cx-color-text</td>
            <td>
              <div class="style-guide__section__content__color-chip background--text"></div>
            </td>
          </tr>
          <tr>
            <td>Background</td>
            <td>--cx-color-background</td>
            <td>
              <div class="style-guide__section__content__color-chip background--background"></div>
            </td>
          </tr>
          <tr>
            <td>Primary</td>
            <td>--cx-color-primary</td>
            <td>
              <div class="style-guide__section__content__color-chip background--primary"></div>
            </td>
          </tr>
          <tr>
            <td>Secondary</td>
            <td>--cx-color-secondary</td>
            <td>
              <div class="style-guide__section__content__color-chip background--secondary"></div>
            </td>
          </tr>
          <tr>
            <td>Link Text</td>
            <td>--cx-color-primary</td>
            <td>
              <div class="style-guide__section__content__color-chip background--primary"></div>
            </td>
          </tr>
          <tr>
            <td>Headline Text</td>
            <td>--cx-color-text</td>
            <td>
              <div class="style-guide__section__content__color-chip background--text"></div>
            </td>
          </tr>
          <tr>
            <td>Headline Link</td>
            <td>--cx-color-text</td>
            <td>
              <div class="style-guide__section__content__color-chip background--text"></div>
            </td>
          </tr>
          <tr>
            <td>Border</td>
            <td>--cx-color-text</td>
            <td>
              <div class="style-guide__section__content__color-chip background--text"></div>
            </td>
          </tr>
          <tr>
            <td>Focus</td>
            <td>--cx-color-visual-focus</td>
            <td>
              <div class="style-guide__section__content__color-chip background--visual-focus"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="style-guide__section">
    <h1 class="style-guide__section">Typography System</h1>
    <div class="style-guide__section__content">
      <div class="style-guide__section__content__typography">
        <h2>Primary font: FS Albert</h2>
        <h3 class="style-guide__section__content__typography__title">Characters</h3>
        <div class="style-guide__section__content__typography__content">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
          standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to
          make a type specimen book. It has survived not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset
          sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus
          PageMaker including versions of Lorem Ipsum.
        </div>
        <h3 class="style-guide__section__content__typography__title">Styles</h3>
        <div class="style-guide__section__content__typography__content">
          <span>FS Albert bold</span>
          <span>FS Albert light</span>
        </div>
      </div>
      <div class="style-guide__section__content__typography">
        <h2>Secondary font: The Serif</h2>
        <h3 class="style-guide__section__content__typography__title">Characters</h3>
        <div class="style-guide__section__content__typography__content">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
          standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to
          make a type specimen book. It has survived not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset
          sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus
          PageMaker including versions of Lorem Ipsum.
        </div>
        <h3 class="style-guide__section__content__typography__title">Styles</h3>
        <div class="style-guide__section__content__typography__content">
          <span>The Serif Light</span>
          <span>The Serif</span>
          <span>The Serif Bold</span>
        </div>
      </div>
      <div class="style-guide__section__content__typography style-guide__section__content__typography--no-right-margin">
        <h2>System font: Calibri</h2>
        <h3 class="style-guide__section__content__typography__title">Characters</h3>
        <div class="style-guide__section__content__typography__content">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
          standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to
          make a type specimen book. It has survived not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset
          sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus
          PageMaker including versions of Lorem Ipsum.
        </div>
        <h3 class="style-guide__section__content__typography__title">Styles</h3>
        <div class="style-guide__section__content__typography__content">
          <span>Calibri Light</span>
          <span>Calibri Regular</span>
          <span>Calibri Bold</span>
        </div>
      </div>
    </div>
  </div>
  <div class="style-guide__section">
    <h1 class="style-guide__section__title">Information Density System</h1>
    <div class="style-guide__section__content">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Mixin value and inputs</th>
            <th scope="col">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>body</td>
            <td>mixin goes here</td>
            <td>The Serif</td>
          </tr>
          <tr>
            <td>headline</td>
            <td>mixin goes here</td>
            <td>FS Albert bold</td>
          </tr>
          <tr>
            <td>fallback</td>
            <td>mixin goes here</td>
            <td>Calibri Regular</td>
          </tr>
          <tr>
            <td>code</td>
            <td>mixin goes here</td>
            <td>Roboto</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <h1 class="style-guide__section">Components</h1>
  <h1 class="style-guide__section">Custom components</h1>
</section>
